module.exports = __webpack_public_path__ + "media/36.f9a6eb6f.mp3";